

import { canlendarDeleteAPI, canlendarQueryByIdAPI, canlendarTodayContractAPI, canlendarTodayCustomerAPI, canlendarTodayLeadsAPI, canlendarTodayBusinessAPI, canlendarTodayDealBusinessAPI } from '@/api/calendar';
import RelatedBusinessCell from '@/views/oa/components/RelatedBusinessCell';
import TaskDetail from '@/views/taskExamine/task/components/TaskDetail';
import CreateEvent from './CreateEvent';
import CheckStatusMixin from '@/mixins/CheckStatusMixin';
import moment from 'moment';
export default {
  name: 'TodayListDetail',
  components: {
    RelatedBusinessCell: RelatedBusinessCell,
    CreateEvent: CreateEvent,
    TaskDetail: TaskDetail,
    CRMFullScreenDetail: function CRMFullScreenDetail() {
      return import('@/components/CRMFullScreenDetail');
    }
  },
  filters: {
    dealIcon: function dealIcon(statu) {
      return statu == '已成交' ? 'wk wk-success deal-suc' : 'wk wk-close deal-un';
    },
    dealName: function dealName(statu) {
      return statu == '已成交' ? '已成交' : '未成交';
    }
  },
  mixins: [CheckStatusMixin],
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    showTodayDetail: {
      type: Boolean,
      default: false
    },
    todayDetailData: {
      type: Object,
      default: function _default() {
        return {
          customerList: []
        };
      }
    },
    cusCheck: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // 详情参数
      showFullDetail: false,
      crmType: 'customer',
      relationID: 0,
      // 任务详情
      taskDetailShow: false,
      taskID: 0,
      detailIndex: -1,

      dialogVisible: false,
      detail: {
        customerList: []
      },
      fieldList: [],
      list: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 30, 45, 60],
      total: 0,
      moreTypes: [{ title: '只删除本次', type: 'delete' }, { title: '删除此系列', type: 'deleteAll' }, { title: '只编辑本次', type: 'edit' }, { title: '编辑本系列', type: 'editAll' }],
      showCreate: false,
      // 是否编辑整个系列
      editAll: false,
      repeatText: '',
      blockColor: '',
      noticeList: [],
      timeList: ['', '分钟', '小时', '天']
    };
  },

  computed: {
    // 相关信息数量
    relatedCount: function relatedCount() {
      var _this = this;

      var count = 0;
      var keys = ['customerList', 'contactsList', 'contractList', 'businessList'];
      keys.forEach(function (key) {
        if (_this.detail[key]) {
          count += _this.detail[key].length;
        }
      });
      return count;
    }
  },
  watch: {
    showTodayDetail: function showTodayDetail(val) {
      this.dialogVisible = val;
      if (val) {
        if (this.id == -1) {
          this.getFieldList();
          this.blockColor = this.todayDetailData.backgroundColor;
          this.detail = {
            customerList: []
          };
        } else {
          this.getDetail();
        }
      }
    },

    detail: {
      handler: function handler(val) {
        if (val.repetitionType !== 1) {
          this.moreTypes = [{ title: '删除', type: 'delete' }, { title: '编辑', type: 'edit' }];
        } else {
          this.moreTypes = [{ title: '只编辑本次', type: 'edit' }, { title: '编辑当前及以后', type: 'editAll' }, { title: '只删除本次', type: 'delete' }, { title: '删除此系列', type: 'deleteAll' }];
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail: function getDetail() {
      var _this2 = this;

      this.loading = true;
      // const startTime = new Date(this.todayDetailData.startTime).getTime()
      // const endTime = new Date(this.todayDetailData.endTime).getTime()
      canlendarQueryByIdAPI({
        event_id: this.id
        // startTime: startTime,
        // endTime: endTime
      }).then(function (res) {
        var detail = res.data || {};
        detail.contactsList = (detail.contacts || []).map(function (item) {
          if (item.contacts_id) {
            item.contactsId = item.contacts_id;
          }
          return item;
        });
        detail.customerList = (detail.customer || []).map(function (item) {
          if (item.customer_id) {
            item.customerId = item.customer_id;
          }
          return item;
        });
        detail.businessList = (detail.business || []).map(function (item) {
          if (item.business_id) {
            item.businessId = item.business_id;
          }
          return item;
        });
        detail.contractList = (detail.contract || []).map(function (item) {
          if (item.contract_id) {
            item.contractId = item.contract_id;
          }
          return item;
        });
        _this2.detail = detail;
        _this2.noticeList = res.data.notice;
        // this.repeatText = this.summaryText()
        _this2.blockColor = _this2.detail.color;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
        _this2.close();
      });
    },


    /**
     * 获取表头
     */
    getFieldList: function getFieldList() {
      if (this.todayDetailData.crmType === 'customer') {
        this.fieldList = [{ label: '客户名称', prop: 'name', width: 105 }, { label: '下次联系时间', prop: 'next_time', width: 135 }, { label: '最后跟进时间', prop: 'last_time', width: 135 }, { label: '负责人', prop: 'owner_user_name', width: 80 }, { label: '创建时间 ', prop: 'create_time', width: 105 }];
      } else if (this.todayDetailData.crmType === 'leads') {
        this.fieldList = [{ label: '线索名称', prop: 'name', width: 105 }, { label: '下次联系时间', prop: 'next_time', width: 135 }, { label: '最后跟进时间', prop: 'last_time', width: 135 }, { label: '负责人', prop: 'owner_user_name', width: 80 }, { label: '创建时间 ', prop: 'create_time', width: 105 }];
      } else if (this.todayDetailData.crmType === 'business') {
        this.fieldList = [{ label: '商机名称', prop: 'name', width: 105 }, { label: '下次联系时间', prop: 'next_time', width: 135 }, { label: '最后跟进时间', prop: 'last_time', width: 135 }, { label: '负责人', prop: 'owner_user_name', width: 80 }, { label: '创建时间 ', prop: 'create_time', width: 105 }];
      } else if (this.todayDetailData.crmType === 'dealBusiness') {
        this.fieldList = [{ label: '商机名称', prop: 'name', width: 105 }, { label: '预计成交时间', prop: 'deal_date', width: 135 }, { label: '最后跟进时间', prop: 'last_time', width: 135 }, { label: '负责人', prop: 'owner_user_name', width: 80 }, { label: '创建时间 ', prop: 'create_time', width: 105 }];
      } else if (this.todayDetailData.crmType === 'receiveContract') {
        this.fieldList = [{ label: '合同编号', prop: 'contract_num', width: 105 }, { label: '客户名称', prop: 'name', width: 105 }, { label: '计划回款期数', prop: 'plan_num', width: 135 }, { label: '计划回款日期', prop: 'return_date', width: 135 }, { label: '计划回款方式', prop: 'return_type', width: 135 }];
      } else {
        this.fieldList = [{ label: '合同编号', prop: 'num', width: 105 }, { label: '合同名称', prop: 'contract_name', width: 105 }, { label: '客户名称', prop: 'name', width: 105 }, { label: '合同金额', prop: 'money', width: 105 }, { label: '开始日期', prop: 'start_time', width: 105 }, { label: '结束日期', prop: 'end_time', width: 105 }, { label: '负责人', prop: 'owner_user_name', width: 80 }];
      }
      this.getList();
    },


    /**
     * 重复文字 暂时去掉
     */
    summaryText: function summaryText() {
      if (this.detail.repetitionType === 1) {
        return '从不重复';
      } else if (this.detail.repetitionType === 2) {
        var day = '';
        if (this.detail.repeatRate == 1) {
          day = '';
        } else {
          day = this.detail.repeatRate;
        }
        return '\u6BCF' + day + '\u5929';
      } else if (this.detail.repetitionType === 3) {
        return '\u6BCF' + this.detail.repeatRate + '\u5468\uFF0C\u6BCF\u5468' + this.detail.repeatTime;
      } else if (this.detail.repetitionType === 4) {
        return '\u6BCF' + this.detail.repeatRate + '\u6708\uFF0C\u7B2C' + this.detail.repeatTime + '\u5929';
      } else if (this.detail.repetitionType === 5) {
        return '\u6BCF' + this.detail.repeatRate + '\u5E74';
      }
    },

    /**
     * 获取宽度
     */
    handelFieldList: function handelFieldList(list) {
      for (var index = 0; index < list.length; index++) {
        var element = list[index];
        var width = 0;
        if (!element.width) {
          if (element.name && element.name.length <= 6) {
            width = element.name.length * 15 + 45;
          } else {
            width = 140;
          }
        } else {
          width = element.width;
        }

        this.fieldList.push({
          prop: element.fieldName,
          label: element.name,
          width: width
        });
      }
    },


    /**
     * 获取列表
     */
    getList: function getList() {
      var _this3 = this;

      var crmIndexRequest = this.getIndexRequest();
      var start_time = new Date(this.todayDetailData.startTime).getTime();
      var end_time = new Date(this.todayDetailData.endTime).getTime();
      var params = {
        page: this.currentPage,
        limit: this.pageSize,
        start_time: start_time,
        end_time: end_time,
        isSub: 1,
        type: 1
      };
      if (this.todayDetailData.userId) {
        params.user_id = this.todayDetailData.userId;
      }
      if (this.todayDetailData.crmType === 'receiveContract') {
        params.type = 2;
      } else if (this.todayDetailData.crmType === 'contract') {
        params.type = 1;
      }
      this.loading = true;
      crmIndexRequest(params).then(function (res) {
        _this3.list = res.data.list;
        _this3.total = res.data.countData;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },


    /**
     * 获取列表请求
     */
    getIndexRequest: function getIndexRequest() {
      if (this.todayDetailData.crmType === 'customer') {
        return canlendarTodayCustomerAPI;
      } else if (this.todayDetailData.crmType == 'leads') {
        return canlendarTodayLeadsAPI;
      } else if (this.todayDetailData.crmType == 'business') {
        return canlendarTodayBusinessAPI;
      } else if (this.todayDetailData.crmType == 'dealBusiness') {
        return canlendarTodayDealBusinessAPI;
      } else {
        return canlendarTodayContractAPI;
      }
    },


    /**
     * 关闭
     */
    close: function close() {
      this.$emit('close');
    },


    /**
     * 数据格式化
     */
    fieldFormatter: function fieldFormatter(row, column, cellValue) {
      if (column.property === 'priority') {
        var list = ['无', '低', '中', '高'];
        return list[cellValue];
      }
      return cellValue === '' || cellValue === null ? '--' : cellValue;
    },


    /**
     * 行点击
     */
    handleRowClick: function handleRowClick(row, column, event) {
      if (this.todayDetailData.crmType === 'customer') {
        if (column.property === 'name') {
          this.relationID = row.customer_id;
          this.crmType = 'customer';
          this.showFullDetail = true;
        } else {
          this.showFullDetail = false;
        }
      } else if (this.todayDetailData.crmType === 'leads') {
        if (column.property === 'name') {
          this.relationID = row.leads_id;
          this.crmType = 'leads';
          this.showFullDetail = true;
        } else {
          this.showFullDetail = false;
        }
      } else if (this.todayDetailData.crmType === 'business' || this.todayDetailData.crmType === 'dealBusiness') {
        if (column.property === 'name') {
          this.relationID = row.business_id;
          this.crmType = 'business';
          this.showFullDetail = true;
        } else {
          this.showFullDetail = false;
        }
      } else if (this.todayDetailData.crmType === 'receiveContract') {
        if (column.property === 'name') {
          this.relationID = row.customer_id;
          this.crmType = 'customer';
          this.showFullDetail = true;
        } else if (column.property === 'num' || column.property === 'contract_num') {
          this.relationID = row.contract_id;
          this.crmType = 'contract';
          this.showFullDetail = true;
        } else {
          this.showFullDetail = false;
        }
      } else {
        if (column.property === 'name') {
          this.relationID = row.customer_id;
          this.crmType = 'customer';
          this.showFullDetail = true;
        } else if (column.property === 'businessName') {
          if (row.business_id) {
            this.relationID = row.business_id;
            this.crmType = 'business';
            this.showFullDetail = true;
          } else {
            this.showFullDetail = false;
          }
        } else if (column.property === 'contactsName') {
          this.relationID = row.contactsId;
          this.crmType = 'contacts';
          this.showFullDetail = true;
        } else if (column.property === 'num') {
          this.relationID = row.contract_id;
          this.crmType = 'contract';
          this.showFullDetail = true;
        } else {
          this.showFullDetail = false;
        }
      }
    },

    /**
     * 每页条数改变
     */
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },


    /**
     * 页数改变
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },


    /**
     * 时间格式化
     */
    formattedTime: function formattedTime(date) {
      var timestemp = new Date(date);
      return moment(timestemp).format('MMMDo HH:mm:ss');
    },

    /**
     * 时间格式化
     */
    timeFormatted: function timeFormatted(date) {
      if (!date) {
        return '';
      }
      var timestemp = new Date(date);
      return moment(timestemp).format('YYYY-MM-DD');
    },

    /**
     * 相关信息的点击
     */
    checkRelatedDetail: function checkRelatedDetail(item, key) {
      this.crmType = key;
      this.relationID = item[key + 'Id'];
      this.showFullDetail = true;
    },


    /**
     * 更多操作
     */
    handleTypeDrop: function handleTypeDrop(command) {
      if (command === 'delete') {
        this.delete(command);
      } else if (command === 'deleteAll') {
        this.delete(command);
      } else if (command === 'edit') {
        this.edit(command);
      } else if (command === 'editAll') {
        this.edit(command);
      }
    },


    /**
     * 删除
     */
    delete: function _delete(type) {
      var _this4 = this;

      this.$confirm('此操作将永久删除该日程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // const timestemp = new Date(this.detail.startTime).getTime()
        var params = {
          event_id: _this4.id
          // time: timestemp,
          // batchId: this.detail.batchId
        };
        if (type === 'delete') {
          params.type = 1;
        } else if (type === 'deleteAll') {
          params.type = 2;
        }
        canlendarDeleteAPI(params).then(function (res) {
          _this4.$message.success('删除成功');
          _this4.$emit('deleteSuccess');
        }).catch(function () {});
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    /**
     * 编辑
     */
    edit: function edit(type) {
      if (type === 'editAll') {
        this.editAll = true;
      } else {
        this.editAll = true;
      }
      this.showCreate = true;
    },


    /**
     * 编辑成功的回调
     */
    handleSure: function handleSure() {
      this.showCreate = false;
      this.$emit('createSuccess');
    },


    /**
     *  0待审核、1审核中、2审核通过、3审核未通过
     */
    getStatusStyle: function getStatusStyle(status) {
      return {
        backgroundColor: this.getStatusColor(status)
      };
    },


    /**
     * 通过回调控制class
     */
    cellClassName: function cellClassName(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (column.property === 'name' || column.property === 'leadsName' || column.property === 'businessName' || column.property === 'num' || column.property === 'contract_num') {
        return 'can-visit--underline';
      } else if (column.property === 'businessCheck') {
        return 'can-visit';
      } else {
        return '';
      }
    }
  }
};